import { render, staticRenderFns } from "./countryNum.vue?vue&type=template&id=dc60b340"
import script from "./countryNum.vue?vue&type=script&lang=js"
export * from "./countryNum.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/www/prod-cn-snote-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dc60b340')) {
      api.createRecord('dc60b340', component.options)
    } else {
      api.reload('dc60b340', component.options)
    }
    module.hot.accept("./countryNum.vue?vue&type=template&id=dc60b340", function () {
      api.rerender('dc60b340', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/charts/countryNum.vue"
export default component.exports